import { Link } from 'react-router-dom'
import { Config } from '@/config'
import s from './logo.module.css'
import { useEffect, useState } from 'react'
import { settingApi } from '@/api'
import { images } from '@/api'

const Logo = () => {
  const { hostname } = new URL(window.location.origin)
  const defLogoUrl = `${process.env.REACT_APP_PATH_FILE}/upload/${
    hostname.split('.')[0]
  }/main-logo.png`

  const [logo, setLogo] = useState(defLogoUrl)

  const loadLogo = (url) => {
    if (!url) return

    images.getAccessCanvas({ imageUrl: url }).then((res) => {
      if (res?.data?.contents) setLogo(res.data.contents)
    })
  }

  useEffect(() => {
    settingApi.getAll().then(({ data }) => {
      data?.map((param) =>
        param.key === 'mainLogo' ? loadLogo(param.value) : null,
      )
    })
  }, [])

  return (
    <div className={s.logoWrap}>
      <Link to="/auth" className={s.logo}>
        <img src={logo} alt={`Школа ${Config.PROJECT_NAME}`} />
      </Link>
    </div>
  )
}

export default Logo
